// productCacheService.js
import localforage from 'localforage';
import axios from 'axios';
import moment from 'moment';
 import customerCacheService from './customerCacheService';

const productStore = localforage.createInstance({
  name: 'dukakit_pos',
  storeName: 'products'
});

const CACHE_PRODUCTS = 'products';
const CACHE_CATEGORIES = 'categories';
const TIMESTAMP_KEY = 'products_last_updated';
const ONE_HOUR = 3 * 60 * 1000;

export default {
  async getProducts(force = false) {
    const now = Date.now();
    const lastUpdated = await productStore.getItem(TIMESTAMP_KEY);
    const isCacheFresh = lastUpdated && (now - lastUpdated < ONE_HOUR);
  console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^🔄 RETURN NOTHING')
    console.log(isCacheFresh,lastUpdated)

    if (!force && isCacheFresh) {
      console.log('📦 Using cached products (fresh)');
      const cached = await productStore.getItem(CACHE_PRODUCTS);
      if (cached) return cached;
    }

    console.log(force ? '^^^^^^^^^^^^^^^^^^^^^^^^^^^^^🔄 Forcing fresh fetch from backend' : '⏳ Cache stale or missing, fetching from backend');

    try {
      const response = await axios.get('/api/betasell');
      const products = response.data.products;
      const categories = response.data.allcategories;

      await productStore.setItem(CACHE_PRODUCTS, products);
      await productStore.setItem(CACHE_CATEGORIES, categories);

      await productStore.setItem(TIMESTAMP_KEY, now);

      console.log('✅ Products updated from backend at', moment.defaultFormat('DD-MM-YYYY h:i-_________________________________________'));
      return products;
    } catch (e) {
      console.warn('⚠️ Backend fetch failed, falling back to cached products');
      const fallback = await productStore.getItem(CACHE_PRODUCTS);
      if (fallback) return fallback;
      throw new Error('❌ Unable to fetch products and no cached data available.');
    }
  },

  async getCategories()
  {
    return productStore.getItem(CACHE_CATEGORIES);
  },
   async hotReloadLocalDB() {
                console.log('🔧 Hot reload started');

                await this.clearCache();


                await this.getProducts(true);
                await customerCacheService.getCustomers(true);
                console.log('✅ Hot reload complete at', new Date().toLocaleTimeString());
            },


  async clearCache() {
    await productStore.removeItem(CACHE_PRODUCTS);
    await productStore.removeItem(CACHE_CATEGORIES);
    await productStore.removeItem(TIMESTAMP_KEY);
    console.log('🧹 Product cache cleared');
  }
};
